import React from 'react';
import './styles/illustration-saga-accueil.css';

// tslint:disable: max-line-length
interface Props {
  width?: number;
  color1?: string;
  color2?: string;
}
function IllustrationSagaHomeSvg(props: Props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 500 320">
      <defs>
        <linearGradient
          id="linear-gradient"
          x1="312.473"
          y1="277.042"
          x2="312.473"
          y2="17.801"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#fff" />
          <stop offset="1" />
        </linearGradient>
        <mask id="mask" x="-27.898" y="8.307" width="680.742" height="271.764" maskUnits="userSpaceOnUse">
          <rect className="cls-1" x="-27.898" y="25.59" width="680.742" height="252.49" />
        </mask>
        <linearGradient
          id="linear-gradient_4"
          x1="-675.158"
          y1="689.877"
          x2="-675.158"
          y2="794.571"
          gradientTransform="translate(-194.724 -722.108) rotate(-57.51)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#ffa1a1" />
          <stop offset="1" stop-color="#ff4137" />
        </linearGradient>
        <linearGradient
          id="linear-gradient_6"
          x1="457.36"
          y1="-53.907"
          x2="514.119"
          y2="-53.907"
          gradientTransform="matrix(0.655, -0.756, 0.756, 0.655, -185.363, 628.861)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#ebeef7" />
          <stop offset="1" stop-color="#9297a5" />
        </linearGradient>
        <linearGradient
          id="linear-gradient_4-2"
          x1="1516.674"
          y1="398.395"
          x2="1488.778"
          y2="347.054"
          gradientTransform="matrix(-0.972, -0.233, -0.233, 0.972, 1984.226, 235.236)"
          xlinkHref="#linear-gradient_4"
        />
        <linearGradient
          id="linear-gradient_6-2"
          x1="1557.225"
          y1="394.469"
          x2="1510.059"
          y2="338.918"
          gradientTransform="matrix(-0.972, -0.233, -0.233, 0.972, 1984.226, 235.236)"
          xlinkHref="#linear-gradient_6"
        />
        <linearGradient
          id="linear-gradient_4-3"
          x1="289.394"
          y1="125.169"
          x2="314.071"
          y2="192.644"
          gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
          xlinkHref="#linear-gradient_4"
        />
      </defs>
      <g id="Calque_3" data-name="Calque 3">
        <g className="cls-2">
          <g id="fond_gradient" data-name="fond gradient" className="cls-3">
            <path
              className="cls-4"
              d="M440.424,280.072c0-5.217-80.4-9.446-179.588-9.446s-179.588,4.229-179.588,9.446C66.423,265.539,58.512,238.71,62.839,218.4s23.31-37.6,23.724-58.36C87.247,125.723,65.894,90.807,78,58.687c9.8-26,34.922-50.38,67.7-50.38,27.778,0,58.45,15.256,83.336,27.6S275.4,62.187,302.9,66.126c19.487,2.793,42.537,1.254,62.031,3.978,43.317,6.048,82.339,37.792,97,79S470.188,248.024,440.424,280.072Z"
            />
          </g>
        </g>
        <g className="cls-5">
          <path
            className="cls-6"
            d="M392.113,249.013a.525.525,0,0,1-.569-.581c8.383-75.279,18.675-129.228,28.979-151.907.228-.5.394-.867.449-1.046a.525.525,0,1,1,1,.312c-.076.241-.234.59-.5,1.168-10.259,22.581-20.519,76.417-28.891,151.589A.524.524,0,0,1,392.113,249.013Z"
          />
          <path
            className="cls-6"
            d="M429.605,91.068c-1.243,2.561-8.824,8.233-9.555,7.878s-.963-9.819.28-12.38a5.155,5.155,0,1,1,9.275,4.5Z"
          />
          <path
            className="cls-6"
            d="M414.76,100.882c1.326,2.593,1.292,12.279.552,12.657s-8.615-5.259-9.942-7.852a5.274,5.274,0,1,1,9.39-4.8Z"
          />
          <path
            className="cls-6"
            d="M427.7,115.439c-2.825.709-12.254-1.506-12.456-2.312s7.065-7.21,9.89-7.919a5.274,5.274,0,1,1,2.566,10.231Z"
          />
          <path
            className="cls-6"
            d="M398.921,152.66c2.684,4.087,4.378,20.256,3.212,21.022s-15.329-7.219-18.012-11.306a8.852,8.852,0,0,1,14.8-9.716Z"
          />
          <path
            className="cls-6"
            d="M423.153,174.61c-4.586,1.694-20.722-.3-21.205-1.605s10.485-13.309,15.071-15a8.852,8.852,0,0,1,6.134,16.608Z"
          />
          <path
            className="cls-6"
            d="M389.687,172.792c4.3,4.156,10.682,23,9.5,24.23s-20.242-4.488-24.546-8.645a10.833,10.833,0,1,1,15.05-15.585Z"
          />
          <path
            className="cls-6"
            d="M423.773,201.087c-5.8,1.485-25.186-2.969-25.609-4.623S412.6,181.583,418.4,180.1a10.833,10.833,0,0,1,5.375,20.989Z"
          />
          <path
            className="cls-6"
            d="M386.211,197.476c4.3,4.156,10.682,23,9.5,24.23s-20.243-4.488-24.546-8.645a10.833,10.833,0,1,1,15.05-15.585Z"
          />
          <path
            className="cls-6"
            d="M420.3,225.771c-5.8,1.485-25.186-2.969-25.61-4.624s14.439-14.88,20.235-16.364a10.833,10.833,0,1,1,5.375,20.988Z"
          />
          <path
            className="cls-6"
            d="M374.6,229.821c5.562,2.2,18.638,17.2,18.009,18.786s-20.426,3.56-25.989,1.357a10.833,10.833,0,1,1,7.98-20.143Z"
          />
          <path
            className="cls-6"
            d="M417.668,250.038c-5.565,2.2-25.36.2-25.987-1.385s12.465-16.569,18.03-18.767a10.833,10.833,0,0,1,7.957,20.152Z"
          />
          <path
            className="cls-6"
            d="M409.9,116.99c1.348,2.635,1.313,12.476.562,12.861s-8.754-5.344-10.1-7.979a5.358,5.358,0,0,1,9.54-4.882Z"
          />
          <path
            className="cls-6"
            d="M422.706,132.027c-2.87.72-12.45-1.53-12.656-2.35s7.178-7.325,10.048-8.045a5.359,5.359,0,0,1,2.608,10.395Z"
          />
          <path
            className="cls-6"
            d="M403.78,132.244c2.215,3.574,3.312,17.511,2.292,18.144s-13.016-6.547-15.232-10.12a7.613,7.613,0,1,1,12.94-8.024Z"
          />
          <path
            className="cls-6"
            d="M423.847,153.281c-4.078,1.023-17.688-2.174-17.981-3.338s10.2-10.407,14.276-11.43a7.613,7.613,0,1,1,3.7,14.768Z"
          />
        </g>
        <g className="cls-5">
          <path
            className="cls-6"
            d="M160.271,249.5a.337.337,0,0,0,.082-.019.419.419,0,0,0,.263-.533c-19.533-57.411-36.88-97.816-48.846-113.771-.266-.354-.457-.61-.532-.74a.42.42,0,0,0-.73.416,10.018,10.018,0,0,0,.59.828c11.914,15.887,29.217,56.208,48.722,113.538A.421.421,0,0,0,160.271,249.5Z"
          />
          <path
            className="cls-6"
            d="M103.729,132.476c1.413,1.788,8.318,4.915,8.828,4.512s-.94-7.844-2.353-9.632a4.127,4.127,0,1,0-6.475,5.12Z"
          />
          <path
            className="cls-6"
            d="M117.027,137.589c-.59,2.256,1.106,9.823,1.75,9.991s5.829-5.6,6.42-7.853a4.223,4.223,0,1,0-8.17-2.138Z"
          />
          <path
            className="cls-6"
            d="M109.418,151.2c2.33.067,9.321-3.29,9.34-3.956s-6.767-4.419-9.1-4.486a4.223,4.223,0,1,0-.243,8.442Z"
          />
          <path
            className="cls-6"
            d="M138.337,175.34c-1.394,3.659.069,16.593,1.113,16.99s10.74-8.286,12.133-11.944a7.087,7.087,0,0,0-13.246-5.046Z"
          />
          <path
            className="cls-6"
            d="M123.176,196.68c3.877.533,16.15-3.8,16.3-4.911s-10.492-8.6-14.37-9.132a7.088,7.088,0,1,0-1.932,14.043Z"
          />
          <path
            className="cls-6"
            d="M149.027,189.489c-2.648,3.991-4.386,19.825-3.247,20.58s15.053-7,17.7-10.99a8.673,8.673,0,0,0-14.454-9.59Z"
          />
          <path
            className="cls-6"
            d="M127.255,217.488c4.788.161,19.18-6.664,19.226-8.031s-13.854-9.145-18.641-9.306a8.673,8.673,0,1,0-.585,17.337Z"
          />
          <path
            className="cls-6"
            d="M156,208.188c-2.649,3.992-4.387,19.825-3.247,20.581s15.052-7,17.7-10.99A8.673,8.673,0,0,0,156,208.188Z"
          />
          <path
            className="cls-6"
            d="M134.229,236.187c4.787.162,19.179-6.663,19.225-8.03s-13.854-9.145-18.641-9.306a8.673,8.673,0,0,0-.584,17.336Z"
          />
          <path
            className="cls-6"
            d="M170.653,231.475c-3.969,2.682-11.606,16.66-10.841,17.793s16.584-.738,20.553-3.42a8.673,8.673,0,1,0-9.712-14.373Z"
          />
          <path
            className="cls-6"
            d="M140.468,254.706c4.73.759,19.862-4.213,20.079-5.563s-12.6-10.805-17.332-11.564a8.673,8.673,0,1,0-2.747,17.127Z"
          />
          <path
            className="cls-6"
            d="M123.6,149.345c-.6,2.293,1.125,9.981,1.779,10.152s5.922-5.687,6.522-7.98a4.29,4.29,0,0,0-8.3-2.172Z"
          />
          <path
            className="cls-6"
            d="M116.184,163.309c2.368.068,9.47-3.342,9.49-4.019s-6.875-4.489-9.244-4.557a4.29,4.29,0,1,0-.246,8.576Z"
          />
          <path
            className="cls-6"
            d="M131.019,160.216c-1.117,3.176.429,14.262,1.335,14.581s9.048-7.363,10.165-10.538a6.095,6.095,0,0,0-11.5-4.043Z"
          />
          <path
            className="cls-6"
            d="M118.956,180.123c3.364.1,13.455-4.749,13.482-5.709s-9.767-6.379-13.131-6.475a6.095,6.095,0,1,0-.351,12.184Z"
          />
        </g>
        <g id="feuilles1">
          <path
            className="cls-7"
            d="M23.523,217.32s13.322,33.821,46.441,54.912,43.193,2.169,43.193,2.169,12.885-17.131-20.234-38.222S23.523,217.32,23.523,217.32Z"
          />
          <path
            className="cls-8"
            d="M113.541,274.646a.3.3,0,0,1-.41.091l-81.67-52.01a.3.3,0,0,1,.318-.5l81.671,52.009A.3.3,0,0,1,113.541,274.646Z"
          />
          <path
            className="cls-8"
            d="M51.539,235.03c.019-.106,1.469-8.255-1-15.358l-.672-.128c2.577,7.006,1.108,15.273,1.089,15.378Z"
          />
          <path
            className="cls-8"
            d="M36.271,225.307a37.353,37.353,0,0,0,.4-7.587c-.2-.018-.4-.034-.591-.05a36.9,36.9,0,0,1-.391,7.529Z"
          />
          <path
            className="cls-8"
            d="M59.57,240.145c.024-.126,1.912-10.724-1.926-18.9l-.754-.185c4.04,8.035,2.12,18.849,2.1,18.975Z"
          />
          <path
            className="cls-8"
            d="M94.2,262.2c.033-.18,2.775-15.562-2.989-27.085-.325-.2-.651-.394-.977-.588,6.26,11.4,3.416,27.383,3.383,27.565Z"
          />
          <path
            className="cls-8"
            d="M106.425,270.247l.584.108c.031-.169,2.448-13.737-2.025-24.931q-.516-.492-1.063-.988C109.024,255.652,106.457,270.074,106.425,270.247Z"
          />
          <path
            className="cls-8"
            d="M73.048,248.842c.03-.159,2.3-12.925-1.922-23.431-.251-.093-.5-.183-.752-.274,4.437,10.415,2.12,23.438,2.091,23.6Z"
          />
          <path
            className="cls-8"
            d="M33.93,236.277a36.767,36.767,0,0,0,11.284-5.062l-.345-.483a36.056,36.056,0,0,1-11.286,5.023C33.7,235.928,33.814,236.1,33.93,236.277Z"
          />
          <path
            className="cls-8"
            d="M55.047,237.478l-.345-.484c-.095.069-7.721,5.426-15.946,6.072l.425.557C47.44,242.828,54.951,237.546,55.047,237.478Z"
          />
          <path
            className="cls-8"
            d="M85.673,256.981l-.345-.484c-.146.1-12.647,8.9-25.247,8.643q.372.3.748.6C73.373,265.632,85.527,257.084,85.673,256.981Z"
          />
          <path
            className="cls-8"
            d="M102.556,267.469c-.149.106-13.136,9.238-25.976,8.618q.609.321,1.206.622c12.64.02,24.969-8.653,25.115-8.757Z"
          />
          <path
            className="cls-8"
            d="M47.5,253.453l.51.541c10.717-1.15,20.393-7.955,20.518-8.044l-.345-.484C68.06,245.556,58.222,252.474,47.5,253.453Z"
          />
          <path
            className="cls-9"
            d="M72.652,173.972s31.409,18.3,47.234,54.231-4.406,43.022-4.406,43.022-18.887,10.139-34.712-25.8S72.652,173.972,72.652,173.972Z"
          />
          <path
            className="cls-8"
            d="M115.664,271.642a.3.3,0,0,0,.152-.391L76.792,182.638a.3.3,0,1,0-.543.239l39.023,88.613A.3.3,0,0,0,115.664,271.642Z"
          />
          <path
            className="cls-8"
            d="M85.908,204.349c-.107,0-8.382.2-15.028-3.318-.009-.229-.018-.457-.025-.683,6.534,3.609,14.928,3.411,15.035,3.408Z"
          />
          <path
            className="cls-8"
            d="M78.613,187.784a37.385,37.385,0,0,1-7.56-.757c.013-.2.026-.4.04-.592a36.886,36.886,0,0,0,7.5.756Z"
          />
          <path
            className="cls-8"
            d="M89.746,213.064c-.128,0-10.89.263-18.387-4.77-.024-.259-.047-.516-.069-.773,7.33,5.211,18.309,4.953,18.437,4.949Z"
          />
          <path
            className="cls-8"
            d="M106.294,250.642c-.183,0-15.8.382-26.318-7.062q-.221-.528-.434-1.056c10.32,7.918,26.549,7.53,26.734,7.524Z"
          />
          <path
            className="cls-8"
            d="M112.394,263.942l.018.593c-.171,0-13.949.336-24.335-5.783q-.408-.584-.815-1.2C97.574,264.3,112.218,263.947,112.394,263.942Z"
          />
          <path
            className="cls-8"
            d="M96.3,227.705c-.161,0-13.124.316-22.868-5.454-.054-.262-.1-.523-.156-.785,9.621,5.966,22.845,5.65,23.006,5.645Z"
          />
          <path
            className="cls-8"
            d="M89.811,187.134A36.8,36.8,0,0,1,83.1,197.519l-.426-.414a36.037,36.037,0,0,0,6.676-10.394C89.5,186.85,89.657,186.992,89.811,187.134Z"
          />
          <path
            className="cls-8"
            d="M87.8,208.188l-.425-.414c.082-.084,6.534-6.809,8.419-14.841.162.168.325.336.487.5C94.238,201.48,87.878,208.1,87.8,208.188Z"
          />
          <path
            className="cls-8"
            d="M102.429,241.417,102,241c.126-.128,10.712-11.151,12.372-23.644q.239.412.474.829C112.845,230.572,102.553,241.289,102.429,241.417Z"
          />
          <path
            className="cls-8"
            d="M110.235,259.7c.128-.131,11.123-11.583,12.458-24.369.149.434.294.863.432,1.286-1.9,12.5-12.339,23.369-12.464,23.5Z"
          />
          <path
            className="cls-8"
            d="M104.73,203.153c.153.194.3.39.457.586-2.761,10.419-10.955,18.951-11.062,19.061l-.426-.414C93.807,222.276,102.137,213.6,104.73,203.153Z"
          />
        </g>
        <path
          className="cls-10"
          d="M76.418,283.972c0,12.32,86.693,22.307,193.634,22.307s193.634-9.987,193.634-22.307-86.693-22.309-193.634-22.309S76.418,271.651,76.418,283.972Z"
        />
        <g id="feuilles2">
          <path
            className="cls-11"
            d="M474.687,198.9s-1.353,31.351-22.445,57.886S417.6,270.71,417.6,270.71s-15.338-10.354,5.755-36.889S474.687,198.9,474.687,198.9Z"
          />
          <path
            className="cls-8"
            d="M417.357,271.018a.256.256,0,0,0,.36-.041l52.014-65.433a.256.256,0,0,0-.4-.319l-52.014,65.433A.256.256,0,0,0,417.357,271.018Z"
          />
          <path
            className="cls-8"
            d="M456.807,221.235c-.045-.08-3.522-6.323-3.5-12.815l.512-.294c-.131,6.443,3.394,12.777,3.439,12.857Z"
          />
          <path
            className="cls-8"
            d="M466.531,209a32.266,32.266,0,0,1-2.461-6.081l.469-.207a31.7,31.7,0,0,0,2.438,6.035Z"
          />
          <path
            className="cls-8"
            d="M451.692,227.67c-.054-.1-4.578-8.213-3.746-15.965.188-.122.375-.243.563-.363-1.036,7.695,3.575,15.98,3.629,16.076Z"
          />
          <path
            className="cls-8"
            d="M429.635,255.419c-.078-.138-6.645-11.92-5.184-22.946.209-.254.421-.505.632-.756-1.9,11.067,4.919,23.31,5,23.449Z"
          />
          <path
            className="cls-8"
            d="M421.926,265.425l-.446.252c-.073-.129-5.864-10.522-5.365-20.916q.283-.546.59-1.1C415.7,254.245,421.851,265.293,421.926,265.425Z"
          />
          <path
            className="cls-8"
            d="M443.141,238.562c-.069-.121-5.518-9.9-5.026-19.664.178-.146.357-.29.536-.435-.69,9.749,4.867,19.725,4.936,19.846Z"
          />
          <path
            className="cls-8"
            d="M471.529,217.3a31.741,31.741,0,0,1-10.633-.956l.145-.491a31.123,31.123,0,0,0,10.625.922Z"
          />
          <path
            className="cls-8"
            d="M454.633,224.221l.145-.492c.1.029,7.829,2.255,14.723.467-.062.191-.126.382-.19.575C462.348,226.446,454.731,224.25,454.633,224.221Z"
          />
          <path
            className="cls-8"
            d="M435.128,248.757l.146-.491c.148.044,12.825,3.7,23.037-.052q-.219.348-.443.695C447.6,252.356,435.276,248.8,435.128,248.757Z"
          />
          <path
            className="cls-8"
            d="M424.3,262.069c.152.045,13.321,3.842,23.625-.278q-.406.433-.808.847c-10.311,3.574-22.814-.034-22.962-.077Z"
          />
          <path
            className="cls-8"
            d="M465.287,235.135q-.13.293-.264.585c-9.07,2.078-18.882-.753-19.009-.79l.145-.492C446.287,234.476,456.263,237.353,465.287,235.135Z"
          />
          <path
            className="cls-12"
            d="M433.956,166.794s-28.305,24.556-37.442,63.989,12.714,42.732,12.714,42.732,21.075,6.647,30.212-32.786S433.956,166.794,433.956,166.794Z"
          />
          <path
            className="cls-8"
            d="M409.122,273.972a.3.3,0,0,1-.229-.367l22.531-97.239a.306.306,0,0,1,.6.138l-22.531,97.239A.305.305,0,0,1,409.122,273.972Z"
          />
          <path
            className="cls-8"
            d="M426.355,200.106c.109-.018,8.529-1.405,14.585-6.244-.035-.233-.07-.466-.105-.7-5.927,4.91-14.467,6.319-14.575,6.336Z"
          />
          <path
            className="cls-8"
            d="M430.567,181.928a38.5,38.5,0,0,0,7.512-2.217c-.051-.2-.1-.4-.154-.592a37.95,37.95,0,0,1-7.454,2.205Z"
          />
          <path
            className="cls-8"
            d="M424.139,209.668c.131-.02,11.08-1.821,17.709-8.358-.025-.266-.052-.531-.078-.8-6.425,6.684-17.6,8.529-17.726,8.55Z"
          />
          <path
            className="cls-8"
            d="M414.584,250.905c.187-.03,16.081-2.644,25.3-12.2q.122-.576.236-1.152c-8.934,10-25.447,12.718-25.635,12.748Z"
          />
          <path
            className="cls-8"
            d="M410.956,265.546l.1.6c.175-.028,14.193-2.335,23.54-10.524q.3-.671.6-1.372C426.035,263.063,411.135,265.517,410.956,265.546Z"
          />
          <path
            className="cls-8"
            d="M420.31,225.755c.164-.026,13.354-2.2,22.117-9.91,0-.276,0-.55.008-.825-8.6,7.888-22.056,10.1-22.221,10.13Z"
          />
          <path
            className="cls-8"
            d="M419.1,183.417a37.924,37.924,0,0,0,8.793,9.231l.352-.5a37.13,37.13,0,0,1-8.756-9.247C419.359,183.07,419.229,183.244,419.1,183.417Z"
          />
          <path
            className="cls-8"
            d="M425.179,204.356l.352-.5c-.1-.069-7.924-5.644-11.374-13.417l-.4.6C417.367,198.8,425.079,204.286,425.179,204.356Z"
          />
          <path
            className="cls-8"
            d="M416.731,240.82l.351-.5c-.152-.106-12.989-9.241-17.066-21.576q-.162.464-.321.93C404.1,231.833,416.58,240.714,416.731,240.82Z"
          />
          <path
            className="cls-8"
            d="M412.329,260.832c-.154-.109-13.488-9.6-17.292-22.294q-.1.7-.191,1.385c4.319,12.295,16.98,21.3,17.132,21.41Z"
          />
          <path
            className="cls-8"
            d="M407.06,202.5c-.117.226-.233.454-.35.681,4.8,10.024,14.731,17.094,14.861,17.185l.351-.5C421.792,219.778,411.691,212.588,407.06,202.5Z"
          />
        </g>
        <g id="nuage1">
          <path
            className="cls-6"
            d="M338.467,65.648a10.55,10.55,0,0,0-19.924-4.843c-.111-.035-.225-.068-.338-.1a13.751,13.751,0,0,0-10.376-4.259A14.968,14.968,0,0,0,300.1,58.5a15.489,15.489,0,0,0-27.482,3.141,11.11,11.11,0,0,0-15.761,5.9,9.29,9.29,0,0,0-12.628,4.3h93.475a10.619,10.619,0,0,0,.105-1.413c0-.341-.019-.678-.051-1.012A10.412,10.412,0,0,0,338.467,65.648Z"
          />
          <path className="cls-8" d="M244.525,71.271l3.563-3.563A9.386,9.386,0,0,0,244.525,71.271Z" />
          <path
            className="cls-8"
            d="M251.281,66.615l-5.22,5.22h.723l5.3-5.3C251.812,66.553,251.544,66.577,251.281,66.615Z"
          />
          <path className="cls-8" d="M254.084,66.634l-5.2,5.2h.723l5.085-5.085Q254.391,66.683,254.084,66.634Z" />
          <path
            className="cls-8"
            d="M256.276,67.265l-4.57,4.57h.723l4.341-4.342C256.608,67.413,256.443,67.336,256.276,67.265Z"
          />
          <path
            className="cls-8"
            d="M263.216,61.048a11.1,11.1,0,0,0-1.387.663L257.6,65.939a11.108,11.108,0,0,0-.649,1.372Z"
          />
          <path className="cls-8" d="M266.008,60.355l-11.48,11.48h.723l11.542-11.541Q266.4,60.311,266.008,60.355Z" />
          <path
            className="cls-8"
            d="M268.805,60.381,257.351,71.835h.723l11.353-11.353C269.222,60.442,269.014,60.409,268.805,60.381Z"
          />
          <path className="cls-8" d="M274.169,58.563l4.524-4.524A15.554,15.554,0,0,0,274.169,58.563Z" />
          <path
            className="cls-8"
            d="M271.066,60.942,260.173,71.835h.723l10.69-10.69C271.415,61.073,271.241,61.006,271.066,60.942Z"
          />
          <path
            className="cls-8"
            d="M282.644,52.186,263,71.835h.723l19.919-19.919C283.3,51.994,282.972,52.087,282.644,52.186Z"
          />
          <path
            className="cls-8"
            d="M286.1,51.552,265.818,71.835h.723l20.313-20.313C286.6,51.527,286.351,51.535,286.1,51.552Z"
          />
          <path className="cls-8" d="M288.866,51.61,268.641,71.835h.723L289.5,51.694Q289.188,51.646,288.866,51.61Z" />
          <path
            className="cls-8"
            d="M291.239,52.059,271.463,71.835h.723L291.8,52.224C291.613,52.166,291.427,52.11,291.239,52.059Z"
          />
          <path
            className="cls-8"
            d="M293.324,52.8,274.285,71.835h.724l18.816-18.817C293.661,52.94,293.492,52.869,293.324,52.8Z"
          />
          <path
            className="cls-8"
            d="M295.184,53.76,277.108,71.835h.723l17.8-17.8C295.481,53.943,295.333,53.851,295.184,53.76Z"
          />
          <path
            className="cls-8"
            d="M296.844,54.922,279.93,71.835h.724l16.583-16.583C297.107,55.14,296.977,55.029,296.844,54.922Z"
          />
          <path
            className="cls-8"
            d="M298.32,56.269,282.753,71.835h.723l15.188-15.188C298.55,56.521,298.438,56.391,298.32,56.269Z"
          />
          <path
            className="cls-8"
            d="M299.611,57.8,285.575,71.835h.724l13.61-13.611C299.811,58.082,299.714,57.939,299.611,57.8Z"
          />
          <path className="cls-8" d="M303.054,57.179,288.4,71.835h.723L304.058,56.9Q303.547,57.023,303.054,57.179Z" />
          <path
            className="cls-8"
            d="M306.556,56.5,291.22,71.835h.723l15.374-15.373C307.062,56.469,306.807,56.479,306.556,56.5Z"
          />
          <path
            className="cls-8"
            d="M309.36,56.517,294.043,71.835h.723l15.241-15.241C309.793,56.565,309.578,56.538,309.36,56.517Z"
          />
          <path
            className="cls-8"
            d="M311.768,56.932l-14.9,14.9h.723l14.746-14.746C312.148,57.034,311.959,56.981,311.768,56.932Z"
          />
          <path
            className="cls-8"
            d="M313.879,57.644,299.688,71.835h.723l13.967-13.967C314.214,57.79,314.048,57.716,313.879,57.644Z"
          />
          <path
            className="cls-8"
            d="M315.734,58.611,302.51,71.835h.723L316.169,58.9C316.027,58.8,315.882,58.7,315.734,58.611Z"
          />
          <path
            className="cls-8"
            d="M317.342,59.826,305.333,71.835h.723l11.656-11.656C317.593,60.059,317.469,59.941,317.342,59.826Z"
          />
          <path className="cls-8" d="M324.232,55.758,308.155,71.835h.723l16.4-16.4A10.6,10.6,0,0,0,324.232,55.758Z" />
          <path
            className="cls-8"
            d="M327.913,55.1c-.068,0-.134.006-.2.007L310.978,71.835h.723L328.416,55.12C328.248,55.112,328.083,55.1,327.913,55.1Z"
          />
          <path className="cls-8" d="M330.268,55.368,313.8,71.835h.723l16.32-16.32Q330.558,55.434,330.268,55.368Z" />
          <path
            className="cls-8"
            d="M332.367,56.091,316.623,71.835h.723l15.509-15.509C332.7,56.241,332.531,56.167,332.367,56.091Z"
          />
          <path
            className="cls-8"
            d="M334.14,57.14,319.445,71.835h.723L334.553,57.45C334.42,57.341,334.279,57.243,334.14,57.14Z"
          />
          <path
            className="cls-8"
            d="M335.634,58.469,322.268,71.835h.723l12.987-12.987C335.868,58.718,335.75,58.594,335.634,58.469Z"
          />
          <path
            className="cls-8"
            d="M336.858,60.066,325.09,71.835h.7c.024,0,11.343-11.318,11.343-11.318C337.046,60.363,336.951,60.216,336.858,60.066Z"
          />
          <path
            className="cls-8"
            d="M337.79,61.957l-9.877,9.878h.723l9.348-9.348C337.927,62.307,337.856,62.134,337.79,61.957Z"
          />
          <path className="cls-8" d="M338.358,64.212l-7.623,7.623h.723l6.969-6.969Q338.4,64.536,338.358,64.212Z" />
          <path className="cls-8" d="M338.363,67.029l-4.806,4.806h.724l3.926-3.926Q338.3,67.476,338.363,67.029Z" />
          <path
            className="cls-8"
            d="M337.813,70.422c0-.019-1.433,1.413-1.433,1.413h.723l.678-.678C337.8,70.915,337.813,70.67,337.813,70.422Z"
          />
        </g>
        <path
          className="cls-13"
          d="M123.316,280.338a.918.918,0,0,1-.89-1.133l3.515-14.366a.915.915,0,1,1,1.778.434L124.2,279.639A.916.916,0,0,1,123.316,280.338Z"
        />
        <path
          className="cls-13"
          d="M103.536,280.338a.918.918,0,0,1-.889-1.133l5.1-20.843a.915.915,0,1,1,1.778.434l-5.1,20.843A.917.917,0,0,1,103.536,280.338Z"
        />
        <path
          className="cls-14"
          d="M111.434,205.126c35.131,0,28.38,36.13,39.451,35.509s16.207,25.475-24.055,25.475S79.1,205.126,111.434,205.126Z"
        />
        <path
          className="cls-15"
          d="M161.133,272.537s-.089,6.209-.041,6.3-.453.866-.453.866l-1.959.351-1.787-.822s.157-5.773-.03-6.683S161.133,272.537,161.133,272.537Z"
        />
        <path
          className="cls-13"
          d="M156.893,279.23a5.1,5.1,0,0,0,4.187-.517s7.516,2.817,7.287,4.959c0,0,.32.638-2.937.5s-8.318-.283-8.454-.358S156.2,284.083,156.893,279.23Z"
        />
        <path
          className="cls-15"
          d="M142.168,272.537s-.089,6.209-.041,6.3-.453.866-.453.866l-1.959.351-1.787-.822s.157-5.773-.03-6.683S142.168,272.537,142.168,272.537Z"
        />
        <path
          className="cls-13"
          d="M137.928,279.23a5.1,5.1,0,0,0,4.187-.517s7.516,2.817,7.287,4.959c0,0,.32.638-2.937.5s-8.318-.283-8.454-.358S137.238,284.083,137.928,279.23Z"
        />
        <path className="cls-16" d="M124.03,200.083s.59-.707.955-.353c.931.905-.2,1.81-.9,1.961Z" />
        <path
          className="cls-15"
          d="M124.567,197.294h-.006c.012-.08.024-.159.033-.24a6.259,6.259,0,1,0-12.182,1.219c.415,1.519.785,2.82,1.208,3.914a8.943,8.943,0,0,1,.233,5.668l-.418,1.468c3.6,2.457,5.55.757,5.55.757l.374-2.737a.7.7,0,0,1,.723-.6h.007C124.863,206.96,124.331,199.429,124.567,197.294Z"
        />
        <path className="cls-13" d="M117.8,199.851a.583.583,0,1,0-.643.515A.583.583,0,0,0,117.8,199.851Z" />
        <path className="cls-13" d="M123.058,199.389a.583.583,0,1,0-.643.515A.583.583,0,0,0,123.058,199.389Z" />
        <path
          className="cls-13"
          d="M115.823,198.719a.342.342,0,0,1-.234-.547,1.831,1.831,0,0,1,2.543-.307.341.341,0,1,1-.371.573,1.151,1.151,0,0,0-1.628.148A.344.344,0,0,1,115.823,198.719Z"
        />
        <path
          className="cls-13"
          d="M121.352,198.413a.341.341,0,0,1-.234-.546,1.831,1.831,0,0,1,2.543-.307.341.341,0,1,1-.37.573,1.152,1.152,0,0,0-1.629.148A.341.341,0,0,1,121.352,198.413Z"
        />
        <polygon
          className="cls-13"
          points="111.548 196.047 112.771 200.442 113.927 200.341 115.205 194.987 111.548 196.047"
        />
        <path
          className="cls-15"
          d="M114.117,200.226a.929.929,0,0,0-.436-.492,1.566,1.566,0,0,0-1.725-.03c-.849.679.465,2.875,2.095,2.036C114.051,201.74,114.533,201.354,114.117,200.226Z"
        />
        <path
          className="cls-16"
          d="M120.542,202.277a1.166,1.166,0,0,1-1.053-.148.1.1,0,0,1,.125-.159.952.952,0,0,0,1.144-.037c.1-.072.153-.133.161-.182.01-.069-.062-.167-.163-.3a2.983,2.983,0,0,1-.639-1.926.1.1,0,0,1,.2,0,2.763,2.763,0,0,0,.6,1.809c.125.169.224.3.2.455a.5.5,0,0,1-.242.315A1.345,1.345,0,0,1,120.542,202.277Z"
        />
        <path
          className="cls-13"
          d="M123.834,194.768s.824.726.627,4.526c0,0,.769-4.175.352-4.69S123.834,194.768,123.834,194.768Z"
        />
        <path
          className="cls-13"
          d="M120.952,204.271a1.873,1.873,0,0,0,.813-.468.092.092,0,0,0,0-.13.093.093,0,0,0-.13,0c-1.218,1.152-2.735-.1-2.8-.151a.092.092,0,0,0-.13.011.093.093,0,0,0,.012.13A2.822,2.822,0,0,0,120.952,204.271Z"
        />
        <path
          className="cls-13"
          d="M111.282,194.631a6.535,6.535,0,0,1,.988-2.571,1.728,1.728,0,0,1-1.276-.175c-.351-.267-.342-.959.09-1.048.251-.052.492.12.746.155.579.079,1-.538,1.186-1.092s.349-1.208.878-1.458a.971.971,0,0,1,.537-.082,3.124,3.124,0,0,1-.279,2.007,8.2,8.2,0,0,1,2.535-2.066,3.225,3.225,0,0,1,2.46-.4c.169.658-.925.97-1.065,1.635a14.718,14.718,0,0,1,4.455-.4,2.962,2.962,0,0,1,1.124.237,1.15,1.15,0,0,1,.674.877.9.9,0,0,1-.947.935,9.482,9.482,0,0,1,2.11,1.221,3.184,3.184,0,0,1,1.2,2.06,3.169,3.169,0,0,1-1.565-.4,1.15,1.15,0,0,1,.44,1.184.909.909,0,0,1-.8.5,2.685,2.685,0,0,1-.972-.186l-4.779-1.549a5.523,5.523,0,0,1,1.294,2.4,7.488,7.488,0,0,1-3.949-1.728,7.467,7.467,0,0,1-.687,1.964.553.553,0,0,1-.2.25c-.322.175-.582-.305-.871-.53a1.2,1.2,0,0,0-1.272.058c-.681.371-1.153.912-1.673.106A3.018,3.018,0,0,1,111.282,194.631Z"
        />
        <path
          className="cls-8"
          d="M153.234,241.68s7.273.589,9.6,9.854c1.356,5.384.824,22.916.824,22.916l-9.43,1.479s.846-19.592-6.457-25.63c0,0,1.479,3.98-3.873,26.621h-7l-2.333-23.19s-16.466.549-21.4-3.568a14.859,14.859,0,0,1-5.436-9.043l23.274-3.537Z"
        />
        <path
          className="cls-13"
          d="M111.428,210.186s.458-3.522,1.19-3.339a70.9,70.9,0,0,0,7.867,1.231c.64-.133,0,2.977,0,2.977s7.311.666,9.141,3.776,6.085,14.921,7.64,15.928a53.638,53.638,0,0,1,4.625,3.806l-12.649,7.115-11.982-.561s-8.667,5.194-15.437,1.15-5.58-25.268.824-29.018S111.428,210.186,111.428,210.186Z"
        />
        <path
          className="cls-13"
          d="M132.725,238.443a.1.1,0,0,1-.037-.008c-3.649-1.594-5.6-17.346-5.687-18.016a.092.092,0,0,1,.08-.1.089.089,0,0,1,.1.08c.02.163,2.025,16.318,5.578,17.87a.092.092,0,0,1-.036.176Z"
        />
        <path
          className="cls-13"
          d="M117.259,241.211a.092.092,0,0,1-.036-.176l2.639-1.153-.369-4.6c-.79-.155-8.214-1.6-11.757-2.015a.091.091,0,0,1-.081-.089c-.006-.355-.131-8.709.419-9.948a.092.092,0,0,1,.168.075c-.507,1.14-.417,8.911-.405,9.79,3.767.449,11.68,2,11.76,2.021a.089.089,0,0,1,.073.082l.38,4.734a.091.091,0,0,1-.055.091l-2.7,1.18A.1.1,0,0,1,117.259,241.211Z"
        />
        <path
          className="cls-13"
          d="M147.776,250.391a.093.093,0,0,1-.09-.075c-.015-.081-1.683-8.132-14.858-9.084a.09.09,0,0,1-.084-.1.088.088,0,0,1,.1-.085c6.955.5,10.669,2.98,12.558,4.97a9.5,9.5,0,0,1,2.467,4.263.09.09,0,0,1-.073.106Z"
        />
        <path
          className="cls-15"
          d="M122.063,235.854l.487.015c1.5.046,5.994.2,6.515.385.627.221-1.261,4.14-1.261,4.14s-5.4.3-7.135-.863S122.063,235.854,122.063,235.854Z"
        />
        <path className="cls-15" d="M127.092,240.419s3.011,1.362,3.278,1.065-2.358-1.818-2.358-1.818Z" />
        <path className="cls-15" d="M127.913,239.454s4.458,1.833,4.8,1.218-4.6-2.208-4.6-2.208Z" />
        <path className="cls-15" d="M128.505,238.373s4.6,1.437,4.884.794-4.772-1.8-4.772-1.8Z" />
        <path className="cls-15" d="M128.739,237.214s4.3,1.4,4.566.759-4.455-1.762-4.455-1.762Z" />
        <polygon
          className="cls-15"
          points="123.091 235.983 119.699 235.558 120.011 239.393 121.756 239.783 123.091 235.983"
        />
        <polygon
          className="cls-17"
          points="161.498 224.118 136.675 224.084 128.866 242.234 153.689 242.269 161.498 224.118"
        />
        <rect
          className="cls-17"
          x="117.122"
          y="241.131"
          width="16.619"
          height="1.098"
          transform="translate(0.338 -0.175) rotate(0.08)"
        />
        <path className="cls-8" d="M146.546,232.91a1.093,1.093,0,1,1,1.1,1.087A1.093,1.093,0,0,1,146.546,232.91Z" />
        <path
          className="cls-18"
          d="M334.826,82.331,190.571,81.322a2.625,2.625,0,0,0-2.643,2.606L186.6,274.079a2.623,2.623,0,0,0,2.606,2.643l144.015,1.007a2.625,2.625,0,0,0,2.643-2.606l1.331-190.391A2.384,2.384,0,0,0,334.826,82.331Z"
        />
        <rect className="cls-8" x="192.194" y="86.42" width="139.408" height="184.525" />
        <rect className="cls-14" x="237.101" y="112.616" width="47.315" height="1.521" rx="0.75" />
        <path
          className="cls-14"
          d="M208.679,163.58H267a.75.75,0,0,1,.75.75v.02a.751.751,0,0,1-.751.751H208.68a.751.751,0,0,1-.751-.751v-.02A.75.75,0,0,1,208.679,163.58Z"
        />
        <rect className="cls-14" x="207.929" y="175.746" width="59.819" height="1.521" rx="0.75" />
        <path
          className="cls-14"
          d="M208.68,169.663h81.13a.75.75,0,0,1,.75.75v.02a.75.75,0,0,1-.75.75H208.679a.75.75,0,0,1-.75-.75v-.02A.751.751,0,0,1,208.68,169.663Z"
        />
        <rect className="cls-14" x="237.101" y="143.032" width="47.315" height="1.521" rx="0.75" />
        <rect className="cls-14" x="225.426" y="120.22" width="70.664" height="1.521" rx="0.75" />
        <rect className="cls-14" x="225.426" y="128.838" width="70.664" height="1.521" rx="0.75" />
        <rect className="cls-14" x="225.426" y="135.935" width="70.664" height="1.521" rx="0.75" />
        <rect className="cls-14" x="207.929" y="193.474" width="59.819" height="1.521" rx="0.75" />
        <rect className="cls-14" x="207.929" y="187.391" width="82.631" height="1.521" rx="0.75" />
        <path
          className="cls-14"
          d="M208.679,205.37H267a.75.75,0,0,1,.75.75v.02a.751.751,0,0,1-.751.751H208.68a.751.751,0,0,1-.751-.751v-.02A.75.75,0,0,1,208.679,205.37Z"
        />
        <path
          className="cls-14"
          d="M208.68,211.453h81.13a.75.75,0,0,1,.75.75v.02a.751.751,0,0,1-.751.751h-81.13a.75.75,0,0,1-.75-.75v-.02a.751.751,0,0,1,.751-.751Z"
        />
        <path
          className="cls-17"
          d="M264.1,264.047a3.271,3.271,0,0,1-1.616-.506,13.149,13.149,0,0,1-6.489-10.361,5.627,5.627,0,0,1,.593-3.271c1.306-2.208,4.4-2.448,6.791-1.543a15.812,15.812,0,0,1,1.555.7c.078-8.117-.53-16.449-3.2-24.186a88.492,88.492,0,0,0-9.263,30.479.8.8,0,0,1-1.59-.18,90.017,90.017,0,0,1,10.284-32.64.8.8,0,0,1,1.448.092c3.388,8.707,4.05,18.155,3.911,27.271a10.95,10.95,0,0,0,2.637,1.049c3.462.762,6.828-1.542,8.633-4.162,2.043-2.964,2.849-6.765,3.559-10.118a.8.8,0,0,1,1.415-.325c.9,1.157.874,2.726.853,4.108-.028,1.763.039,2.563.791,2.828a3.047,3.047,0,0,0,2.139-.576,61.679,61.679,0,0,1,20.781-6.611c.672-.089,1.354-.169,2.04-.25,4.43-.524,9.012-1.066,12.125-3.946a.8.8,0,0,1,1.087,1.174c-3.5,3.234-8.34,3.806-13.024,4.361-.679.08-1.354.159-2.019.247a60.089,60.089,0,0,0-20.244,6.441,4.346,4.346,0,0,1-3.417.669c-1.729-.609-1.872-2.331-1.865-3.867a21.607,21.607,0,0,1-2.9,6.774c-2.109,3.059-6.114,5.739-10.294,4.815a10.762,10.762,0,0,1-2.33-.842c-.088,3.394-.27,6.732-.446,9.957a2.613,2.613,0,0,1-.874,2.084A1.792,1.792,0,0,1,264.1,264.047Zm-3.4-14.577a3.036,3.036,0,0,0-2.739,1.254,3.993,3.993,0,0,0-.375,2.345,11.7,11.7,0,0,0,5.692,9.086c.5.288.844.337.953.258.167-.12.2-.685.208-.872.189-3.456.385-7.042.463-10.684a18.471,18.471,0,0,0-2.094-1A6.065,6.065,0,0,0,260.7,249.47Z"
        />
        <polygon
          className="cls-15"
          points="319.474 195.719 324.956 194.911 321.76 191.945 318.881 191.014 317.268 192.566 319.474 195.719"
        />
        <path
          className="cls-17"
          d="M367.571,159.226c.741,1.915.491,4.1,1.188,6.029a10.173,10.173,0,0,0,3.744,4.485,9.385,9.385,0,0,1,3.145,3c1.44,2.889-1.017,6.548.237,9.523.573,1.361,1.88,2.417,2.058,3.884a3.394,3.394,0,0,1-1.352,2.956,6.218,6.218,0,0,1-3.141,1.174,10.886,10.886,0,0,1-2.885-.033c-1.068-.156-2.106-.471-3.167-.669a14.8,14.8,0,0,0-6.684.294c-1.658.464-3.27,1.224-4.991,1.24a9.442,9.442,0,0,1-3.281-.685,9.574,9.574,0,0,1-3.2-1.765,8.99,8.99,0,0,1-2.455-4.592c-.425-1.71-.592-3.475-1-5.189a18.793,18.793,0,0,0-2.727-6.179,9.489,9.489,0,0,1-1.424-2.478,5.255,5.255,0,0,1-.161-1.943,8.7,8.7,0,0,1,4.36-6.78,12.144,12.144,0,0,0,1.8-1.04A7.608,7.608,0,0,0,349,158.823q1.139-1.637,2.386-3.193a6.325,6.325,0,0,1,1.456-1.442,5.706,5.706,0,0,1,2.292-.72C359.34,152.868,365.864,154.812,367.571,159.226Z"
        />
        <path
          className="cls-15"
          d="M345.816,285.567s.856,8.453-.87,9.412c-3.125,1.736-8.89,3.392-8.407,4.884s14.3,1.549,14.683.189-1.165-5.521.476-13.621Z"
        />
        <path
          className="cls-13"
          d="M351.084,297.016a12.186,12.186,0,0,1,.138,3.036c-.383,1.36-14.2,1.3-14.683-.189-.358-1.106,2.693-2.353,5.588-3.6C342.812,297.418,344.272,299.211,351.084,297.016Z"
        />
        <path
          className="cls-15"
          d="M371.731,285.325s2.283,8.183.746,9.422c-2.784,2.243-8.182,4.857-7.453,6.244s14.355-.908,14.5-2.313-2.087-5.242-1.85-13.5Z"
        />
        <path
          className="cls-13"
          d="M378.872,295.709a12.2,12.2,0,0,1,.653,2.969c-.146,1.405-13.771,3.7-14.5,2.313-.541-1.029,2.253-2.777,4.895-4.493C370.79,297.514,372.533,299.032,378.872,295.709Z"
        />
        <path
          className="cls-15"
          d="M340.533,188.667s-2.9,3.887-5.321,3.887-15.87-8.406-15.87-8.406l-.952,3.471s11.138,12.795,17.426,12.916,11.006-6.893,10.885-7.256-4.112-4.612-4.112-4.612Z"
        />
        <path
          className="cls-8"
          d="M347.426,210.634a33.98,33.98,0,0,0-5.446,9.867c-1.693,5.322,2.8,68.368,2.8,68.368h7.5s3.978-56.146,3.978-56.645c0-1.96,14.766,56.645,14.766,56.645h7.486s-4.051-68.621-13.454-78.235l-8.8.544Z"
        />
        <path className="cls-13" d="M347.426,208.275v2.359s4.475,4.353,17.627,0l.03-2.359-11.549-.725Z" />
        <path
          className="cls-18"
          d="M351.9,179.832s-4.661-.173-7.026,1.459c-1.692,1.168-5.427,7.755-5.427,7.755l4.288,3.645a5.305,5.305,0,0,0,2.97,5.97l.723,9.614s7.5,4.354,17.657,0c0,0,1.935-18.019,3.749-16.447a23.89,23.89,0,0,1,2.9,2.963l6.772-6.712s-7.383-7.4-9.826-8.556a11.812,11.812,0,0,0-10.367-.1Z"
        />
        <path
          className="cls-15"
          d="M372.369,194.163s3.931,4.589,3.478,5.858-7.395,11.727-8.323,13.709a5.342,5.342,0,0,0-.657,3.162l3.537,1.723s.184-2.8.954-3.621,12.47-12.887,12.2-16.7-5.642-9.631-5.642-9.631Z"
        />
        <path className="cls-15" d="M349.852,165.08s-.513-1.006-1.046-.682c-1.359.828-.155,2.27.645,2.643Z" />
        <path
          className="cls-15"
          d="M359.008,154.626a7.674,7.674,0,0,1,5.228,11.452,33.147,33.147,0,0,1-3.727,6.009,7.635,7.635,0,0,0-1.942,5.245l.055,1.952c-4.69,1.712-6.522.535-6.522.535l.651-5.7h0c-4.733-1.12-3.081-9.9-2.782-12.52l.007,0c.008-.1.015-.2.026-.3A7.677,7.677,0,0,1,359.008,154.626Z"
        />
        <path
          className="cls-17"
          d="M358.728,162.407a31.9,31.9,0,0,1,3.2,5.381c.088.212.7,1.8.455,1.947a9.891,9.891,0,0,0,3.125-3.438,8,8,0,0,0-5.645-11.989,8.451,8.451,0,0,0-7.832,2.161c-1.837,1.989-2.223,4.725-2.7,7.279.535-2.867,4.667-4.578,7.112-5.332-.072.022,1.446,2.694,1.528,2.826C358.217,161.633,358.47,162.021,358.728,162.407Z"
        />
        <path
          className="cls-15"
          d="M361.666,167.949a1.145,1.145,0,0,1,.655-.47,1.924,1.924,0,0,1,2.072.434c.829,1.043-1.339,3.311-3.06,1.864C361.333,169.777,360.862,169.184,361.666,167.949Z"
        />
        <path className="cls-13" d="M351.106,165.3a.67.67,0,1,1,.658.682A.669.669,0,0,1,351.106,165.3Z" />
        <path className="cls-13" d="M357.307,166.719a.67.67,0,1,1,.658.681A.67.67,0,0,1,357.307,166.719Z" />
        <path
          className="cls-19"
          d="M351.776,169.991s.881-.635,1.22-.53a1,1,0,0,1,.513.525.776.776,0,0,1,.634-.4c.417.008,1.279,1.158,1.279,1.158s-1.244,1.794-2.5,1.523c-1.276-.277-1.137-2.184-1.137-2.184Z"
        />
        <path
          className="cls-17"
          d="M359.4,165.952a.279.279,0,0,0,.239-.466,3.34,3.34,0,0,0-2.032-.93.277.277,0,0,0-.3.254.284.284,0,0,0,.254.3,2.791,2.791,0,0,1,1.671.754A.275.275,0,0,0,359.4,165.952Z"
        />
        <path
          className="cls-17"
          d="M353.01,163.98a.278.278,0,0,0,.122-.509,3.3,3.3,0,0,0-2.193-.422.278.278,0,0,0-.233.318.281.281,0,0,0,.318.232,2.772,2.772,0,0,1,1.8.337A.268.268,0,0,0,353.01,163.98Z"
        />
        <path
          className="cls-16"
          d="M354.022,168.911a1.191,1.191,0,0,1-.952-1.173.234.234,0,0,1,.071-.159,3.462,3.462,0,0,0,.876-2.062.235.235,0,0,1,.469.022,3.939,3.939,0,0,1-.942,2.3c.025.189.166.621.918.67a.234.234,0,1,1-.03.468A2.093,2.093,0,0,1,354.022,168.911Z"
        />
        <path
          className="cls-20"
          d="M351.776,169.991l3.646.755a4.372,4.372,0,0,1-2.355.747C352.078,171.345,351.776,169.991,351.776,169.991Z"
        />
        <path
          className="cls-8"
          d="M358.976,197.336c3.4,0,4.819-3.4,4.833-3.435a.126.126,0,1,0-.233-.095c-.014.033-1.371,3.278-4.6,3.278a5.056,5.056,0,0,1-4.5-2.381.126.126,0,0,0-.17-.054.125.125,0,0,0-.054.169A5.323,5.323,0,0,0,358.976,197.336Z"
        />
        <path
          className="cls-8"
          d="M343.733,192.817a.126.126,0,0,0,.125-.111,7.209,7.209,0,0,1,2.052-3.948.126.126,0,1,0-.172-.183,7.339,7.339,0,0,0-2.131,4.1.127.127,0,0,0,.111.14Z"
        />
        <path
          className="cls-10"
          d="M351.415,211.327a2.219,2.219,0,1,1,2.218,2.218A2.221,2.221,0,0,1,351.415,211.327Zm1.007,0a1.211,1.211,0,1,0,1.211-1.211A1.212,1.212,0,0,0,352.422,211.327Z"
        />
        <path
          className="cls-21"
          d="M381.1,217.341,315.682,182.18a34.1,34.1,0,1,0-3.8,7.062L377.3,224.4ZM270.524,194.693a28.393,28.393,0,1,1,38.452-11.566A28.424,28.424,0,0,1,270.524,194.693Z"
        />
        <path
          className="cls-22"
          d="M297.41,144.674a28.393,28.393,0,1,0,11.566,38.453A28.395,28.395,0,0,0,297.41,144.674Z"
        />
        <path
          className="cls-23"
          d="M287.145,148.649a24.6,24.6,0,0,1,17.364,7.147,24.673,24.673,0,1,0-38.069,30.946,24.67,24.67,0,0,1,20.7-38.093Z"
        />
        <path
          className="cls-15"
          d="M319.474,195.719s2-3.238,1.578-3.576-2.537,1.815-2.517,1.771,1.855-2.653,1.457-3.294-2.724,1.946-2.724,1.946,1.9-2.32,1.6-2.744-2.359,1.6-2.5,1.46,1.76-1.742,1.415-2.283-3.116,1.616-3.04,2.338a.928.928,0,0,0,.813.8s.259,1.2.912,1.352c0,0,.914,1.4,1.6,1.125C318.074,194.618,318.3,196.065,319.474,195.719Z"
        />
        <path
          className="cls-15"
          d="M371.072,209.927s-2.976,1.492-4,2.111-2.465.464-2.325,1.141,2.41.357,2.41.357-1.271,2.065-1.758,2.641-1.1,1.826-.7,2.215,2.54-2.539,2.54-2.539-1.565,2.643-1.279,3.079,2.772-2.633,2.772-2.633a20.2,20.2,0,0,0-1.762,3.076c.046.338.481.293,1.356-.521a11.389,11.389,0,0,0,1.559-1.87,25.523,25.523,0,0,0-1.176,2.308c-.051.289.091.724,1.259-.618s3.2-4.554,3.557-6.627Z"
        />
        <g id="nuage2">
          <path
            className="cls-6"
            d="M153.483,106.431a9.839,9.839,0,0,1,7.805,3.846,7.669,7.669,0,0,1,10.786-2.634,14.482,14.482,0,0,1,28.412,1.221,6.936,6.936,0,0,1,6.045,4.55,5.163,5.163,0,0,1,5,4.95h-67.7a9.862,9.862,0,0,1,9.648-11.933Z"
          />
          <path className="cls-8" d="M198.435,103.312a14.557,14.557,0,0,0-4.589-4.588Z" />
          <path className="cls-8" d="M198.435,103.312l-4.589-4.588A14.557,14.557,0,0,1,198.435,103.312Z" />
          <path className="cls-8" d="M190.267,97.108c-.3-.089-.6-.169-.914-.239Z" />
          <path className="cls-8" d="M189.353,96.869c.309.07.613.15.914.239l9.783,9.783c.089.3.166.6.235.91Z" />
          <path
            className="cls-8"
            d="M202.449,109.289l4.053,4.054c.009.024.02.047.029.071.015,0,.03,0,.046,0l4.947,4.947h-.676l-9.358-9.357A6.872,6.872,0,0,1,202.449,109.289Z"
          />
          <path className="cls-8" d="M187.066,96.546q-.35-.021-.7-.027Z" />
          <path
            className="cls-8"
            d="M187.066,96.546l21.819,21.818h-.677L186.363,96.519Q186.717,96.525,187.066,96.546Z"
          />
          <path className="cls-8" d="M184.494,96.613c-.2.022-.4.049-.6.081Z" />
          <path
            className="cls-8"
            d="M184.494,96.613l21.751,21.751h-.676L183.9,96.694C184.1,96.662,184.294,96.635,184.494,96.613Z"
          />
          <path className="cls-8" d="M182.284,97.042c-.175.049-.349.1-.521.155Z" />
          <path
            className="cls-8"
            d="M182.284,97.042l21.322,21.322h-.676L181.763,97.2C181.935,97.142,182.109,97.091,182.284,97.042Z"
          />
          <path className="cls-8" d="M180.339,97.736q-.234.1-.462.214Z" />
          <path
            className="cls-8"
            d="M180.339,97.736l20.628,20.628h-.676L179.877,97.95Q180.105,97.839,180.339,97.736Z"
          />
          <path className="cls-8" d="M178.605,98.642c-.139.085-.276.174-.412.264Z" />
          <path
            className="cls-8"
            d="M178.605,98.642l19.723,19.722h-.676L178.193,98.906C178.329,98.816,178.466,98.727,178.605,98.642Z"
          />
          <path className="cls-8" d="M177.06,99.735c-.125.1-.248.2-.369.308Z" />
          <path
            className="cls-8"
            d="M177.06,99.735l18.629,18.629h-.676l-18.322-18.321C176.812,99.938,176.935,99.836,177.06,99.735Z"
          />
          <path className="cls-8" d="M175.688,101c-.111.116-.22.232-.326.351Z" />
          <path
            className="cls-8"
            d="M175.688,101l17.362,17.362h-.677l-17.011-17.011C175.468,101.234,175.577,101.118,175.688,101Z"
          />
          <path className="cls-8" d="M174.485,102.439c-.1.13-.19.261-.281.4Z" />
          <path
            className="cls-8"
            d="M174.485,102.439l15.925,15.925h-.676l-15.53-15.53C174.3,102.7,174.389,102.569,174.485,102.439Z"
          />
          <path className="cls-8" d="M173.458,104.051c-.08.147-.158.294-.233.444Z" />
          <path
            className="cls-8"
            d="M173.458,104.051l14.313,14.313H187.1L173.225,104.5C173.3,104.345,173.378,104.2,173.458,104.051Z"
          />
          <path className="cls-8" d="M172.623,105.856c-.062.164-.12.331-.177.5Z" />
          <path
            className="cls-8"
            d="M172.623,105.856l12.509,12.508h-.676l-12.01-12.01C172.5,106.187,172.561,106.02,172.623,105.856Z"
          />
          <path className="cls-8" d="M171.383,107.254a7.716,7.716,0,0,0-1.143-.467Z" />
          <path
            className="cls-8"
            d="M171.383,107.254l11.11,11.11h-.676L170.24,106.787A7.716,7.716,0,0,1,171.383,107.254Z"
          />
          <path className="cls-8" d="M167.921,106.432c-.218,0-.432.012-.645.03Z" />
          <path
            className="cls-8"
            d="M167.921,106.432l11.933,11.932h-.677l-11.9-11.9C167.489,106.444,167.7,106.432,167.921,106.432Z"
          />
          <path className="cls-8" d="M165.637,106.787q-.254.079-.5.177Z" />
          <path
            className="cls-8"
            d="M165.637,106.787l11.578,11.577h-.677l-11.4-11.4Q165.384,106.867,165.637,106.787Z"
          />
          <path className="cls-8" d="M163.837,107.626q-.207.13-.4.273Z" />
          <path
            className="cls-8"
            d="M163.837,107.626l10.738,10.738H173.9L163.434,107.9Q163.63,107.757,163.837,107.626Z"
          />
          <path className="cls-8" d="M162.387,108.816q-.165.172-.319.356Z" />
          <path
            className="cls-8"
            d="M162.387,108.816l9.549,9.548h-.676l-9.192-9.192Q162.222,108.989,162.387,108.816Z"
          />
          <path className="cls-8" d="M159.2,108.267a9.8,9.8,0,0,0-1.613-.936Z" />
          <path className="cls-8" d="M159.2,108.267l10.1,10.1h-.676l-11.034-11.033A9.8,9.8,0,0,1,159.2,108.267Z" />
          <path className="cls-8" d="M154.818,106.524c-.249-.034-.5-.061-.753-.076Z" />
          <path
            className="cls-8"
            d="M154.818,106.524l11.84,11.84h-.676l-11.917-11.916C154.319,106.463,154.569,106.49,154.818,106.524Z"
          />
          <path className="cls-8" d="M152.181,106.527c-.2.026-.394.052-.587.089Z" />
          <path
            className="cls-8"
            d="M152.181,106.527l11.838,11.837h-.677l-11.748-11.748C151.787,106.579,151.984,106.553,152.181,106.527Z"
          />
          <path className="cls-8" d="M150.066,107.051c-.164.06-.33.117-.49.186Z" />
          <path
            className="cls-8"
            d="M150.066,107.051l11.313,11.313H160.7l-11.127-11.127C149.736,107.168,149.9,107.111,150.066,107.051Z"
          />
          <path className="cls-8" d="M148.293,107.917c-.139.086-.279.17-.413.263Z" />
          <path
            className="cls-8"
            d="M148.293,107.917l10.447,10.447h-.676L147.88,108.18C148.014,108.087,148.154,108,148.293,107.917Z"
          />
          <path className="cls-8" d="M146.795,109.058c-.118.108-.237.213-.349.327Z" />
          <path
            className="cls-8"
            d="M146.795,109.058l9.306,9.306h-.676l-8.979-8.979C146.558,109.271,146.677,109.166,146.795,109.058Z"
          />
          <path className="cls-8" d="M145.548,110.45c-.1.13-.195.257-.285.392Z" />
          <path
            className="cls-8"
            d="M145.548,110.45l7.914,7.914h-.676l-7.523-7.522C145.353,110.707,145.452,110.58,145.548,110.45Z"
          />
          <path className="cls-8" d="M144.561,112.1c-.072.154-.146.306-.211.464Z" />
          <path
            className="cls-8"
            d="M144.561,112.1l6.262,6.261h-.676l-5.8-5.8C144.415,112.409,144.489,112.257,144.561,112.1Z"
          />
          <path className="cls-8" d="M143.879,114.06c-.043.186-.079.374-.112.564Z" />
          <path
            className="cls-8"
            d="M143.879,114.06l4.305,4.3h-.677l-3.74-3.74C143.8,114.434,143.836,114.246,143.879,114.06Z"
          />
          <path className="cls-8" d="M143.618,116.438c0,.24.017.478.037.713Z" />
          <path
            className="cls-8"
            d="M143.618,116.438l1.926,1.926h-.676l-1.213-1.213C143.635,116.916,143.622,116.678,143.618,116.438Z"
          />
        </g>
      </g>
    </svg>
  );
}

export default IllustrationSagaHomeSvg;
